var request = new XMLHttpRequest();
request.open('HEAD', window.location.href, true);
request.send();

request.onreadystatechange = function() {
	if (this.readyState === 4) {
		// サーバーから時刻を取得
		var serverDate = new Date(request.getResponseHeader('Date'));

		// JSONからデータを取得し、画面に表示する
		$(window).on('load', function() {
			// ポイントアップキャンペーン
			var pointcpJson = '/material/json/pointcpList.json';
			fetch(pointcpJson)
				.then(response => response.json())
				.then(data => formatCpJSON(data, serverDate));
			// 使えるお店
			var allianceJson = '/material/json/allianceList.json';
			fetch(allianceJson)
				.then(response => response.json())
				.then(data => formatAllianceJSON(data));
		});
	}
};

// JSONから取得したデータを整形し、画面に表示する
var formatCpJSON = function(json, serverDate) {
	// 表示するデータ
	var displayCpData = [];
	// データを抽出
	for (let i = 0; i < json.length; i++) {
		var cpBlock = json[i];
		var cpData = cpBlock.data;
		// 表示するデータを絞り込む
		for (let n = 0; n < cpData.length; n++) {
			var data = cpData[n];
			if (timeCheck(data.startDate, data.endDate, serverDate)) {
				displayCpData.push(data);
			};
		}
	}
	if (displayCpData.length > 0) {
		// 絞り込んだデータをhtml表記に整形
		var sliderListItemHTML = '';
		for (let l = 0; l < displayCpData.length; l++) {
			var sliderItemFrontHTML = '<li class=\"pointcp-slider__item icon__open-modal ' + displayCpData[l].id + '\" id=\"' + displayCpData[l].id + '\"><div class=\"pointcp-store';
			var sliderItemBackHTML = '</div></div></li>';
			var itemHTML = '';
			if (displayCpData[l].logoPath) {
				itemHTML = '\"><div class=\"pointcp-store__logo\"><img src=\"' + displayCpData[l].logoPath + '\" alt=\"' + displayCpData[l].imgAltName + '\">';
			} else {
				itemHTML = ' text-item\"><div class=\"pointcp-store__text\"><span class=\"store-name\">' + displayCpData[l].storeName + '</span>';
			}
			sliderListItemHTML += (sliderItemFrontHTML + itemHTML + sliderItemBackHTML);
		}
		$('#pointcp-slider')[0].innerHTML = sliderListItemHTML;
	}
	pointcpSlickUnset();
};

var formatAllianceJSON = function(json) {
	// データを抽出
	for (let i = 0; i < json.length; i++) {
		var block = json[i];
		var listName = block.category + '__list';
		var blockData = block.data;
		var storeListHTML = '';
		for (let n = 0; n < blockData.length; n++) {
			var data = blockData[n];
			// htmlに記載するdata-typeを設定
			var dataType = [];
			if (data.tamaru) {
				dataType.push('tamaru');
			}
			if (data.charge) {
				dataType.push('charge');
			}
			if (data.zandaka) {
				dataType.push('zandaka');
			}
			if (data.koukan) {
				dataType.push('koukan');
			}
			var dataTypeStr = dataType.join('\',\'');
			// データのアイコンのみを取り出しhtml表記に整形
			var iconHTML = '<div class=\"search-result__logo\"><img src=\"' + data.logoPath + '\" alt=\"' + data.imgAltName + '\"></div>';
			// ジャンルごとのブロックの配下に取得したデータを表示する
			var gridItemHTML = '<div class=\"grid-item icon__open-modal\" id=\"' + data.id + '\"><div class=\"search-result Nanaco_StoreSearchLink\" target=\"_blank\" data-type=\"[\'' + dataTypeStr + '\']\">' + iconHTML + '</div></div>';
			storeListHTML += gridItemHTML;
		}
		$('#' + listName)[0].innerHTML = storeListHTML;
	}
	// URLにパラメータがある場合
	var urlParam = location.search.substring(1);
	if (urlParam) {
		filterByUrlParam(urlParam);
	}
	// URLにハッシュ値がある場合
	var urlHash = location.hash;
	if (urlHash) {
		scrollToUrlHash(urlHash);
	}
};

// 開始日、終了日を基に、表示非表示を判定する
var timeCheck = function(startDate, endDate, serverDate) {
	// 各加盟店ごとに境界時間を取得
	var limitDateAStart = new Date(startDate);
	var limitDateAEnd = new Date(endDate);
	// 各境界時間までの秒数を宣言
	var rTimeAStart = (limitDateAStart - serverDate) / 1000;
	var rTimeAEnd = (limitDateAEnd - serverDate) / 1000;
	return rTimeAStart < 0 && !(rTimeAEnd < 0);
};

// URLで指定されている条件でフィルター
var filterByUrlParam = function(urlParam) {
	var storage = sessionStorage;
	var filterWord;
	var name = 'filter-store';
	if (urlParam) {
		var param = urlParam.split('&');
		var paramArray = [];
		for (i = 0; i < param.length; i++) {
			var paramItem = param[i].split('=');
			paramArray[i] = paramItem[1];
		}
		for (i = 0; i < paramArray.length; i++) {
			filterWord = paramArray[0];
			if (i > 0) {
				filterWord += ',' + paramArray[i];
			}
		}
		storage.setItem(name, filterWord);
	}
	if (storage.getItem(name)) {
		setTimeout(function() {
			var services = storage.getItem(name).split(',');
			for (var i in services) {
				var btn = $('[name=filtering][value=' + services[i] + ']');
				if (btn.length) {
					btn.trigger('click');
				}
				filtering();
				showHideWrapper();
			}
			storage.removeItem(name);
		}, 0);
	}
}

// URLで指定されている位置までスクロールする
var scrollToUrlHash = function(urlHash) {
	if ($(urlHash).length) {
		var position = $(urlHash).offset().top;
		var headerHeight = $('#js-header').outerHeight();
		if ($(window).width() > 768) {
			position -= headerHeight;
		}
		position -= 20;
		$('html,body').animate({ scrollTop: position }, 900);
	}
};
